import {
	fetchComuni,
	fetchNazioni,
	fetchRegioni,
	resetNazioni,
} from "components/anagrafiche/comuni/comuniSlice";
// import { fetchProduttori } from "./anagrafiche/produttori/produttoriSlice";

import {
	// utenteTokenRefresh,
	UtenteLogged,
} from "components/authentication/authenticationSlice";
import {
    fetchCommerciali,
    fetchMacchine,
    fetchMandatari,
    fetchStagioni,
    fetchTecniche
} from "./anagrafiche/anagraficheSlice";

// import { conteggioTaskAttivi } from "components/tasks/tasksSlice";

export const fetchAnagrafiche = (
	dispatch: any,
	utente: UtenteLogged,
	ritardoScaglionamento: number, // Ritarda ogni dispatch di 1000 == secondo
	comuniUltimoAggiornamento?: string
) => {
	const actions = [
		// () => dispatch(conteggioTaskAttivi({})),
		() =>
			// dispatch(fetchComuni({ ultimoAggiornamento: comuniUltimoAggiornamento })),
		() => dispatch(fetchRegioni({})),
		() => dispatch(fetchNazioni({})),
		() => dispatch(fetchCommerciali()),
		() => dispatch(fetchMandatari()),
		() => dispatch(fetchStagioni()),
		() => dispatch(fetchTecniche()),
		() => dispatch(fetchMacchine()),
	];

	//

	if (utente.isLogged) {
		actions.forEach((action, index) => {
			setTimeout(action, index * ritardoScaglionamento); // Ritarda ogni dispatch di 1 secondo
		});
	}
};

export const resetAnagrafiche = (dispatch: any) => {
	dispatch(resetNazioni());
};
